import { useState, useEffect, useRef } from "react";
import GetIcon from "../../../../utils/Icon";
import EditItemModal from "./EditItemModal";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import ConfigureColumns from "./ConfigureColumns";
import Pagination from "../../../../Components/Pagination";

const Table = ({ setDeliveryNoteItems, list_data, row, fulldata, save }) => {
  console.log(list_data, "row-full");
  console.log(fulldata, "fulldata-full");

  const getRowColor = (currentcolurraw) => {
    // if (!scanboll) return; 


    console.log(currentcolurraw, "row-new");
    const itemRows = row.Rows.filter(r => r.item_code === currentcolurraw.item_code);
    const totalScanQty = itemRows.reduce((sum, r) => sum + Number(r.scan_qty), 0);
    const tottalqty = itemRows.reduce((sum, r) => sum + Number(r.qty), 0);


    if (totalScanQty === 0) return 'not-distributedt';
    if (totalScanQty === tottalqty) return 'fully-distributedt';

    if (totalScanQty >= row.qty) return 'fully-distributedt';
    return 'partially-distributedt';
  };
  const tableRef = useRef(null);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showError, setShowError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [columeConfModal, setcolumeConfModal] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);



  const [visibleColumns, setVisibleColumns] = useState([
    { name: "S.No", selected: true, key: "sno", width: "5%" },
    { name: "Item Code", selected: true, key: "item_code", width: "17%" },
    { name: "Item Name", selected: true, key: "item_name", width: "25%" },
    { name: " Qty", selected: true, key: "qty", width: "6%" },
    { name: "UOM", selected: false, key: "uom", width: "7%" },
    { name: "Rate", selected: true, key: "rate", width: "10%" },
    { name: "Amount", selected: true, key: "amount", width: "10%" },
    { name: "Reject Qty", selected: false, key: "rejected_qty", width: "80px" },
    { name: "Barcode", selected: false, key: "barcode", width: "80px" },
    { name: "Manufacturing Date", selected: false, key: "manufacturing_date", width: "80px" },
    { name: "Expiry Date", selected: false, key: "expiry_date", width: "80px" },
    { name: "Serial No.", selected: false, key: "serial_numbers", width: "70px" },
    { name: "Batch No.", selected: false, key: "batch_no", width: "70px" },
    { name: "Box Id", selected: false, key: "parent", width: "19%" },
    { name: "Settings", selected: true, key: "settings", width: "4%" },

  ]);
  const [removedSerials, setRemovedSerials] = useState([]);
  console.log(removedSerials, "removedSerials_myr");

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row.Rows.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    row.setRows(list_data);
  }, [list_data]);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, [visibleColumns]);

  const openEditModal = (item, index) => {
    console.log(item, index, "myr_check");

    const filterdata = fulldata.filter((realitem) => realitem.item_code == item.item_code && realitem.idx == item.idx);
    setfull_Item_Detail(filterdata[0]);
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index);
    setShowEditModal(true);
  };

  const handleItemChange = (updatedItem) => {
    setCurrentItem(updatedItem);
  };

  const saveEdit = () => {
    const updatedRows = [...row.Rows];

    // Update the specific row with the modified item data
    updatedRows[currentIndex] = currentItem;

    row.setRows(updatedRows);
    setDeliveryNoteItems(updatedRows); // Also update the parent state if needed

    setShowEditModal(false);
    setRemovedSerials([]); // clear removed serials
  };


const handleInputChange = (index, field, value) => {
  const globalIndex = indexOfFirstRow + index;

  const updatedRows = [...row.Rows];
  const updatedRow = { ...updatedRows[globalIndex] };

  // Convert to integer if the field is a quantity-related one
  if (["accepted_qty", "qty", "rejected_qty", "scan_qty"].includes(field)) {
    updatedRow[field] = value === "" ? "-" : parseInt(value, 10) || 0;
  } else {
    updatedRow[field] = value;
  }

  updatedRows[globalIndex] = updatedRow;
  row.setRows(updatedRows);
};


  const handleSaveColumns = (columns) => {
    setVisibleColumns(columns);
  };


  const renderTableHeader = () => {
    return visibleColumns
      .filter(column => column.selected)
      .map((column, index) => {
        if (column.key === "settings") {
          return (
            <th key={index} onClick={() => setcolumeConfModal(true)} style={{ width: column.width, minWidth: column.width }}>
              <GetIcon iconName="IoSettingsOutline" size={13} />
            </th>
          );
        }
        return <th key={index} style={{ width: column.width, minWidth: column.width }}>
          {column.name}</th>;
      });
  };


  const renderTableRow = (rowData, rowIndex) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    return visibleColumns
      .filter(column => column.selected)
      .map((column, colIndex) => {
        const key = column.key;


        if (key === "sno") {
          return (
            <td key={colIndex} className="p-0" style={{ textAlign: 'center', height: '30px', }}>
              <p className="mb-0" style={{ position: 'relative', top: '3px', height: '30px' }}>
                {globalIndex + 1}
              </p>
            </td>
          );
        }
        if (key === "settings") {
          return (
            <td key={colIndex} className="p-0" style={{ height: '30px', }}>
              <span onClick={() => openEditModal(rowData, rowIndex)} style={{ position: 'relative', top: '4px', height: '30px', }}>
                <GetIcon iconName="MdOutlineEdit" size={15} />
              </span>
            </td>
          );
        }
        if (key === "rate") {
          const handleRateChange = (e) => {
            const newValue = e.target.value;
            handleInputChange(rowIndex, key, newValue); // Always update the input value
          };

          const handleRateBlur = (e) => {
            const newValue = e.target.value;

            // Allow empty value
            if (newValue === "") {
              return;
            }

            // Check if it's a valid number
            const newValueNum = parseFloat(newValue);
            if (isNaN(newValueNum)) {
              // Reset to original value if not valid
              handleInputChange(rowIndex, key, rowData.rate);
              return;
            }

            const currentValue = parseFloat(rowData.rate) || 0;

            // Only allow decreasing the rate (new value must be <= current value)
            if (newValueNum > currentValue) {
              // If user entered a higher value, revert to current value
              handleInputChange(rowIndex, key, rowData.rate);
            }
          };

          return (
            <td key={colIndex} className="p-0" style={{ height: '30px', textAlign: 'center', verticalAlign: 'middle' }}>
              <input
                type="text"
                className="form-control noborder"
                onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: key })}
                onBlur={(e) => {
                  setFocusedCell({ rowIndex: null, field: null });
                  handleRateBlur(e);
                }}
                style={{
                  height: '25px',
                  fontSize: '0.8rem',
                  background: 'transparent',
                  textAlign: 'center',
                  padding: '0 5px',
                  margin: '0 auto'
                }}
                value={rowData[key]}
                onChange={handleRateChange}
                title="Rate can only be decreased (cannot be higher than current value)"
              />
            </td>
          );
        }

        if (["accepted_qty", "qty", "rejected_qty", "expiry_date", "manufacturing_date", 'scan_qty'].includes(key)) {
          const isSerializedItem = rowData.serial_no && rowData.serial_no.trim() !== "";
          return (
            <td key={colIndex} className="p-0 d-flex justify-content-center" style={{ height: '30px', border: focusedCell.rowIndex === globalIndex && focusedCell.field === key ? '0.3px solid #270b79' : '' }}>
              <input
                type={key.includes("date") ? "date" : "text"}
                className="form-control noborder"
                onFocus={() => !isSerializedItem && setFocusedCell({ rowIndex: globalIndex, field: key })}
                onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                style={{
                  height: '30px',
                  fontSize: '0.8rem',
                  background: 'transparent',
                  width: key == "accepted_qty" ? '44%' : '',
                  cursor: isSerializedItem ? 'not-allowed' : 'text',
                  opacity: isSerializedItem ? 0.6 : 1
                }}
                value={rowData[key]}
                onChange={(e) => !isSerializedItem && handleInputChange(rowIndex, key, e.target.value)}
                disabled={isSerializedItem}
                title={isSerializedItem ? "Cannot edit quantity for serialized items. Use edit modal to manage serials." : ""}
              />
            </td>
          );
        }

        return <td key={colIndex} className="p-0" style={{ height: '30px', }}>
          <p className="mb-0" style={{ position: 'relative', top: '3px', height: '30px' }}>
            {key == "amount" ? `₹${rowData[key]}` : rowData[key]}
          </p>
        </td>;
      });
  };

  return (
    <>
      <table className="table table-bordered" ref={tableRef} style={{ height: '30px' }}>
        <thead className="tableHead1" style={{ height: '30px' }}>

          <tr style={{ height: '30px', }}>
            {renderTableHeader()}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((crrow, index) => (
            <tr style={{ height: '30px', }} className={` ${getRowColor(crrow)} ${crrow.item_code == row?.selectedItem?.item_code ? 'blinkbackground' : ''}`} key={index}>{renderTableRow(crrow, index)}</tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-1 mb-3 centerpagination">
        {row.Rows.length > 10 ? <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={rowsPerPage}
          totalrecords={row.Rows.length}
          currentPage={currentPage}
        /> : ''}

        {row.Rows.length > 10 ? <div>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79', position: 'relative', top: '-6px' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, row.Rows.length)} of {row.Rows.length} entries
          </span>
        </div> : ''}



      </div>

      <ConfigureColumns
        show={columeConfModal}
        onClose={() => setcolumeConfModal(false)}
        onSave={handleSaveColumns}
        initialFields={visibleColumns}
      />

      <EditItemModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        full_Item_Detail={full_Item_Detail}
        itemData={currentItem}
        onChange={handleItemChange}
        onSave={saveEdit}
        removedSerials={removedSerials}
        setRemovedSerials={setRemovedSerials}
      />

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default Table;